import columnAvc from './avc';
import columnMam from './mam';
import columnProstata from './prostata';
import columnQuadril from './quadril';
import columnSca from './sca';
import columnSepse from './sepse';

export const getGrid = lc => {
  switch (lc) {
    case 'acidente_vascular_cerebral':
      return columnAvc;
    case 'cancer_de_mama':
      return columnMam;

    case 'cancer_de_prostata':
      return columnProstata;

    case 'artropatia_de_quadril':
      return columnQuadril;

    case 'sindrome_coronariana_aguda':
      return columnSca;

    case 'sepse_e_choque_septico':
      return columnSepse;
    default:
      return null;
  }
};
